const blog = {
  'blog.page.backToTop': 'Back to top',
  'blog.page.lastUpdated': 'Last updated: 13 June 2026',

  'blog.hero.homeLink': 'Home',
  'blog.hero.currentPage': 'Blog',
  'blog.hero.title': 'The Butler\'s Blog',
  'blog.hero.titleEn': 'BUTLER\'S BLOG',
  'blog.hero.lead': 'Practical insights into butler technique, etiquette, and career — written by our academy instructors drawing on real-world experience.',
  'blog.hero.imgAlt': 'A butler reading in a well-appointed study',

  'blog.list.all': 'All',
  'blog.list.empty': 'No articles in this category yet.',
  'blog.list.readMore': 'Read More',
  'blog.list.categoryTitle': 'Browse by Category',

  'blog.cat.A': 'Butler Fundamentals',
  'blog.cat.B': 'Butler Careers',
  'blog.cat.C': 'Etiquette in Practice',
  'blog.cat.D': 'Academy News',
  'blog.cat.E': 'Industry & International',

  'blog.detail.backToList': 'Back to Blog',
  'blog.detail.authorLabel': 'Author',
  'blog.detail.tocTitle': 'Contents',
  'blog.detail.relatedTitle': 'Related Articles',
  'blog.detail.shareTitle': 'Share This Article',
  'blog.detail.updatedLabel': 'Updated',
  'blog.detail.publishedLabel': 'Published',
};

export default blog;
